<template>
  <div class="datapicker-wrapper"
    :title="title"
    :class="{ 'disabled': disabled }">
    <div v-if="hasPrefix" class="prefix" :style="prefixStyle">{{prefix}}</div>
    <div v-if="hasPrefix && showSeparator" class="separator-line"></div>
    <input
      type="date"
      class="date-picker-input"
      :id="id"
      @input="onInput"
      :class="{'empty': !hasValue}"
      :placeholder="placeholder"
      v-model="currentValue"
      :min="minValue"
      :max="maxValue"
      :readonly="readonly"
      :required="required"
      :disabled="disabled" />
    <!-- <div v-if="hasValue" class="dropdown-value">{{currentValue}}</div> -->
    <!-- <div class="dropdown-arrow-icon"></div> -->
    <div v-if="!disabled && showClearIcon" @click="currentValue=null" class="clear-icon"></div>
  </div>
</template>

<script>
export default {
  name: 'DataPickerBox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    prefixColor: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Date | String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showSeparator: {
      type: Boolean,
      default: false
    },
    showClearIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    minValue: {
      type: [Date, String, Number],
      default: null
    },
    maxValue: {
      type: [Date, String, Number],
      default: null
    },
  },
  data () {
    return {
      id: null
    }
  },
  computed: {
    hasPrefix() {
      return this.prefix && this.prefix != '';
    },
    hasValue() {
      return this.value && this.value.toString().length;
    },
    currentValue: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit('change', value);
      }
    },
    prefixStyle() {
      if (this.prefixColor && this.prefixColor != '') {
        return `color: ${this.prefixColor}!important`;
      }
      return null;
    },
  },
  methods: {
    onInput(event) {
      this.$emit('input', this.currentValue);
      this.handleChange(event);
    },
    handleChange(event) {
      const inputEl = event.target;
      
      // Браузер сам проверяет input на основе pattern, required, minlength, maxlength
      // inputEl.validity.valid возвращает true или false
      const isValid = inputEl.validity.valid === true;

      // Генерируем событие validation для родителя и передаем статус валидности
      // console.log('text-box.handleChange, emit change.isValid:' + isValid);
      this.$emit('validation', isValid);
    },
  },
  mounted () {
    this.id = `date-picker_${this._uid}`;
  }
}
</script>
<style scoped>
.datapicker-wrapper .prefix {
  /* margin-right: 7px; */
  margin: 3px 7px 3px 0;
  white-space: break-spaces;
  text-align: right;
}
/* .datapicker-wrapper .separator-line {
  border-right: 1px solid var(--hr-color);
  width: 1px;
  background: none;
  box-shadow: inset 1px 1px 1px 1px #00000045;
  height: calc(1em + 2px);
  margin-top: 2px;
  margin-right: 7px;
  display: inline-flex;
} */
  .datapicker-wrapper .separator-line {
  align-self: normal;
  border-right: 1px solid var(--hr-color);
  width: 1px;
  background: none;
  box-shadow: inset 1px 1px 1px 1px #00000045;
  display: inline-flex;
  margin: 3px 7px 3px 0;
}
.datapicker-wrapper input[type="date"] {
  font: inherit;
  margin-right: auto;
  background: inherit;
  color: var(--textColor);
  border: none;
  border-radius: 0;
  outline: none;
  color-scheme: dark;
  /* align-self: flex-start; */
  align-self: anchor-center;
  padding: 3px 0;
  height: 1em;
}
.datapicker-wrapper input[type="date"].empty {
  color: var(--textColorDisabled);
}
.datapicker-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  font: inherit;
  height: 100%;
  padding: 0 10px;
  width: calc(100% - 22px);
  max-width: calc(100% - 22px);
  background: var(--input-box-background);
  border-radius: var(--ui-control-border-radius);
  border: 1px solid var(--border-color);
  margin-bottom: 1rem;
}
.datapicker-wrapper .clear-icon {
  cursor: pointer;
}
.datapicker-wrapper .clear-icon::after {
  content: "✖";
  color: var(--textColorDisabled);
  margin-right: 0.5em;
}

/* Базовые стили для вашего класса */
.date-picker-input {
  width: 100%;
  box-sizing: border-box;
  font-family: inherit; /* Чтобы шрифт цифр совпадал с другими полями */
}

/* Радикальное исправление для readonly-состояния */
.date-picker-input[readonly] {
  /* Полностью отключаем нативный браузерный движок отображения даты */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
 
  /* Разрешаем тексту занимать всю доступную ширину */
  min-width: 0; 
}

/* Дублируем скрытие иконок для Chromium (для надежности) */
.date-picker-input[readonly]::-webkit-calendar-picker-indicator,
.date-picker-input[readonly]::-webkit-inner-spin-button,
.date-picker-input[readonly]::-webkit-clear-button {
  display: none !important;
  -webkit-appearance: none !important;
  margin: 0 !important;
}
</style>